module.exports = __webpack_public_path__ + "img/lod.f0295708.jpg";